import { Component, OnInit } from '@angular/core';
import { BasePagedPage } from '../../base-paged-page';
import { CityModel } from 'src/app/models/store/city.model';
import { Router } from '@angular/router';
import { PagedResponseModel } from 'src/app/models/common/paged-response.model';
import { PagedSearchModel } from 'src/app/models/common/paged-search.model';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-cities',
  templateUrl: './cities.component.html',
  styleUrl: './cities.component.scss',
  standalone: false
})
export class CitiesComponent extends BasePagedPage<string, CityModel> implements OnInit {

  constructor(private mApiService: ApiService, private mRouter: Router) {
    super();
  }

  public override getData(page?: number | undefined): void {
    if (!page) { return; }

    this.isBusy = true;

    this.mApiService.getWithParams<PagedSearchModel<string>, PagedResponseModel<CityModel>>('/api/admin/city/list', {
      page: page ?? 1,
      pageSize: this.pageSize,
      search: this.search
    }).subscribe({
      next: r => {
        this.items = r.items;

        this.page = page;
        this.pages = r.pages;

        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  ngOnInit(): void {
    this.getData(1);
  }

  public addNew() {
    this.mRouter.navigate(['/cities/edit/new']);
  }

  public deleteItem(id: string) {
    if (!confirm('Удалить этот город?')) {
      return;
    }

    this.isBusy = true;

    this.mApiService.delete('/api/admin/city/' + id).subscribe({
      next: () => {
        this.getData(this.page);
      }, error: () => this.isBusy = false
    });
  }

  public setValue(change: { order: number, name?: string }, event: any) {

    let newOrder = parseInt(event.target.value);
    if (!(newOrder > 0)) {
      return;
    }

    const maxOrder = Math.max(...this.items.map(i => i.order));

    if (newOrder > maxOrder) {
      newOrder = maxOrder;
    }

    const previewOrder = change.order;

    for (let item of this.items) {
      if (item.order <= newOrder && item.order >= previewOrder) {
        item.order--;
        if (item.order < 1) {
          item.order = 1;
        }
      }
    }

    change.order = newOrder

    // find same order in items
    let hasSameOrder = false;
    for (let item of this.items) {
      if (item.name !== change.name && item.order == change.order) {
        hasSameOrder = true;
        break;
      }
    }

    if (hasSameOrder) {
      for (let item of this.items) {
        if (item.order >= change.order && item.name != change.name) {
          item.order++;
        }
      }
    }

    this.items = this.items.sort((a, b) => a.order - b.order);

    this.items.forEach((x, index) => { x.order = index + 1 });

    this.isBusy = true;

    const saveObj: { [id: string]: number } = {};

    for (const item of this.items) {
      saveObj[item.id!] = item.order;
    }

    this.mApiService.post<{}, PagedResponseModel<CityModel>>('/api/admin/city/order', saveObj).subscribe({
      next: (r) => {

        this.isBusy = false;
        this.items = r.items;

        this.page = 1;
        this.pages = r.pages;

        this.isBusy = false;
      },
      error: () => {
        this.isBusy = false;
      }
    });
  }

}
